import Button from "components/Button/Button";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfileLayout from "components/Layout/ProfileLayout";
import { ProfileCard } from "components/Card/ProfileCard";

import { useForm } from "react-hook-form";
import Input from "components/Form/Input";
import makeToast from "utils/toast/makeToast";
import actionApi from "services/actionApi";
import InputFile from "components/Form/InputFile";

const ProfileEditPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [profile, setProfile] = useState({});

  useEffect(() => {
    actionApi
      .getProfile()
      .then((response) => {
        setProfile(response?.data);
      })
      .catch()
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const {
    register,
    watch,
    formState: { errors, isValid },
    setError,
    setValue,
    handleSubmit,
  } = useForm({});

  const isDisabled = isSubmitting || !isValid || Object.keys(errors).length > 0;

  const onSubmit = async (payload) => {
    delete payload["email"];

    setIsSubmitting(true);
    await actionApi
      .editProfile({ ...payload })
      .then(() => {
        navigate("/profile");
        makeToast({ label: "Changes have been saved", type: "success" });
      })
      .catch((err) => {
        makeToast({ label: err?.response?.data?.errors?.[0], type: "failed" });
      });
  };

  return (
    <ProfileLayout profile={profile}>
      <ProfileCard>
        {isLoading && !profile?.name ? (
          ""
        ) : (
          <form
            className="flex flex-col gap-8"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="flex justify-between items-center">
              <span className="sm:text-2xl font-medium text-wce-navy">
                Your Profile
              </span>
              <div>
                <Button
                  size="large"
                  rounded
                  type="submit"
                  disabled={isDisabled}
                >
                  Save Changes
                </Button>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex flex-col gap-6">
                <Input
                  {...register("name", { required: true })}
                  title={"Name"}
                  defaultValue={profile?.name}
                  placeholder="Full Name"
                />

                <Input
                  {...register("phone", { required: true })}
                  title={"Phone Number"}
                  defaultValue={profile?.phone}
                  placeholder="Phone Number"
                />
                <Input
                  title={"Email"}
                  defaultValue={profile?.email}
                  disabled={true}
                />
                <Input
                  {...register("linkedin_url", { required: true })}
                  title={"URL LinkedIn Account"}
                  defaultValue={profile?.linkedin_url}
                  placeholder="URL LinkedIn Account"
                />
              </div>
              <div className="flex flex-col gap-6">
                <Input
                  {...register("education", { required: true })}
                  title={"Education"}
                  defaultValue={profile?.education}
                  placeholder="Education (ex: S1)"
                />
                <Input
                  {...register("institution", { required: true })}
                  title={"Institution"}
                  defaultValue={profile?.institution}
                  placeholder="Institution (ex: Universitas Indonesia)"
                />
                <InputFile
                  {...register("cv_file_id", { required: true })}
                  setValue={setValue}
                  errors={errors}
                  placeholder={"Upload your CV (.pdf)"}
                  title="Your CV"
                  type="cv"
                  email={profile?.email}
                  defaultValue={profile?.cv_file_id}
                  defaultName={profile?.cv_name}
                  defaultSize={profile?.cv_size}
                  isModal={true}
                />
              </div>
            </div>
          </form>
        )}
      </ProfileCard>
    </ProfileLayout>
  );
};

export default ProfileEditPage;
